const Build = ({onNext}) => {
  return (
    <div className='buildCoverImage' onClick={onNext}>
      {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
  <path strokeLinecap="round" strokeLinejoin="round" d="M15.042 21.672L13.684 16.6m0 0l-2.51 2.225.569-9.47 5.227 7.917-3.286-.672zm-7.518-.267A8.25 8.25 0 1120.25 10.5M8.288 14.212A5.25 5.25 0 1117.25 10.5" />
</svg> */}
                <img src="https://scrappy-afe2cd64144028-staging.s3.ap-south-1.amazonaws.com/public/public/nextWhite.png" alt="" className='buildGoNext' onClick={onNext} />


      {/* <div className='tapeLabel'  onClick={onNext}>
        <img src="/Images/tape.png" alt="Tape" />
        <h1 className='tapeHeading'>Scrappy Make, Build</h1>
      </div> */}
    </div>
  )
}

export default Build
